import { type NCWalletTopMovingTokensProps, useNCWalletTopMovingTokens } from '@capsicum/features/nc-wallet/shared';

import { NCWalletTokenCards } from '../nc-wallet-token-cards/NCWalletTokenCards';

export const NCWalletTopMovingTokens = ({ excludeShortCodes }: NCWalletTopMovingTokensProps) => {
	const { balances, isLoading, onClick } = useNCWalletTopMovingTokens({
		excludeShortCodes
	});

	return (
		<NCWalletTokenCards
			entries={balances}
			isLoading={isLoading}
			name="top-moving-tokens"
			title="ncWallet.home.topMovingTokens"
			onBodyClick={onClick}
			onLogoClick={onClick}
		/>
	);
};
